import { GeneralAssemblyMembersSection } from './GeneralAssemblyMembersSection';

export function GeneralAssemblySection() {
  return <GeneralAssemblyMembersSection />;
}

